<template>
  <v-container>
    <v-row justify="space-around">
      <v-card class="ma-4">
        <v-card-title class="headline lighten-2"> Vue Webcam </v-card-title>

        <v-card-text>
          <p>
            Current Camera:
            <span
              ><code v-if="device">{{ device.label }}</code></span
            >
          </p>

          <web-cam
            ref="webcam"
            :device-id="deviceId"
            height="100%"
            width="100%"
            @started="onStarted"
            @stopped="onStopped"
            @error="onError"
            @cameras="onCameras"
            @camera-change="onCameraChange"
          />
          <v-select
            :items="devices"
            :item-value="deviceId"
            item-text="label"
            label="Select Device"
          ></v-select>

          <p v-if="img">Preview:</p>
          <v-img :src="img" contain></v-img>
          <div class="text-center">
            <v-btn
              depressed
              v-if="img"
              @click="img = null"
              class="ma-2"
              fab
              dark
              small
              color="red"
            >
              <v-icon dark> mdi-close-circle-outline </v-icon>
            </v-btn>
          </div>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            depressed
            @click="onCapture"
            class="mx-2"
            fab
            dark
            small
            color="green"
          >
            <v-icon dark> mdi-camera-iris </v-icon>
          </v-btn>
          <v-btn
            depressed
            @click="onStop"
            class="mx-2"
            fab
            dark
            small
            color="red"
          >
            <v-icon dark> mdi-camera-off </v-icon>
          </v-btn>
          <v-btn
            depressed
            @click="onStart"
            class="mx-2"
            fab
            dark
            small
            color="warning"
          >
            <v-icon dark> mdi-camera </v-icon>
          </v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-row>
  </v-container>
</template>

<script>
import { WebCam } from "vue-web-cam";
export default {
  data() {
    return {
      img: null,
      camera: null,
      deviceId: null,
      devices: [],
      obj: null,
    };
  },
  watch: {
    camera: function (id) {
      this.deviceId = id;
    },
    devices: function () {
      // Once we have a list select the first one
      const [first, ...tail] = this.devices;
      if (first) {
        this.camera = first.deviceId;
        this.deviceId = first.deviceId;
      }
    },
  },
  components: {
    WebCam,
  },
  methods: {
    onCapture() {
      this.img = this.$refs.webcam.capture();
      fetch(this.img)
        .then((res) => res.blob())
        .then((blob) => {
          const file = new File([blob], "dot.png", blob);
          console.log(file);
          this.obj = file;
        });
      this.$toasted.show("Your smile has been captured", {
        type: "success",
        duration: 5000,
        position: "top-center",
        theme: "bubble",
        icon: "mdi-alert-circle",
        iconPack: "mdi",
      });
    },
    onStarted(stream) {
      console.log("On Started Event", stream);
      this.$toasted.show("On Started Event", {
        type: "success",
        duration: 5000,
        position: "top-center",
        theme: "bubble",
        icon: "mdi-alert-circle",
        iconPack: "mdi",
      });
    },
    onStopped(stream) {
      console.log("On Stopped Event", stream);
      this.$toasted.show("On Stopped Event", {
        type: "danger",
        duration: 5000,
        position: "top-center",
        theme: "bubble",
        icon: "mdi-alert-circle",
        iconPack: "mdi",
      });
    },
    onStop() {
      this.$refs.webcam.stop();
    },
    onStart() {
      this.$refs.webcam.start();
    },
    onError(error) {
      console.log("On Error Event", error);
      this.$toasted.show("On Error Event", {
        type: "danger",
        duration: 5000,
        position: "top-center",
        theme: "bubble",
        icon: "mdi-alert-circle",
        iconPack: "mdi",
      });
    },
    onCameras(cameras) {
      this.devices = cameras;
      console.log("On Cameras Event", cameras);
      this.$toasted.show("On Cameras Event", {
        type: "success",
        duration: 5000,
        position: "top-center",
        theme: "bubble",
        icon: "mdi-alert-circle",
        iconPack: "mdi",
      });
    },
    onCameraChange(deviceId) {
      this.deviceId = deviceId;
      this.camera = deviceId;
      console.log("On Camera Change Event", deviceId);
      this.$toasted.show("On Camera Change Event", {
        type: "success",
        duration: 5000,
        position: "top-center",
        theme: "bubble",
        icon: "mdi-alert-circle",
        iconPack: "mdi",
      });
    },
  },
  computed: {
    device: function () {
      return this.devices.find((n) => n.deviceId === this.deviceId);
    },
  },
};
</script>

<style>
</style>